<h2 mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content>
  <glxy-form-field>
    <mat-radio-group>
      @for (association of associationFormArray.controls; track association; let i = $index) {
        <glxy-label class="primary-text-color">{{ association?.get('name')?.value }}</glxy-label>
        <div class="radio-wrapper">
          <mat-radio-button
            class="primary-text-color"
            [checked]="$safeNavigationMigration(association?.get('isPrimary')?.value)"
            [value]="$safeNavigationMigration(association?.get('id')?.value)"
            (change)="setPrimaryAssociation(i)"
            >
            {{ data.primarySelect }}
            <extended>{{ data.description }}</extended>
          </mat-radio-button>
          <crm-edit-association-tags
            [tags]="association?.get('tags')?.value ?? []"
            [associationType]="data.associationType"
            (tagsChanged)="tagsChanged(i, $event)"
          ></crm-edit-association-tags>
        </div>
      }
    </mat-radio-group>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'ACTIONS.ADD' | translate }}
  </button>
</mat-dialog-actions>
